import _extends from "@babel/runtime/helpers/esm/extends";
import { makeStyles } from 'tss-react/mui';
export default makeStyles()(function (theme) {
  var _theme$palette$tertia;
  return {
    root: {
      fontFamily: 'Montserrat, sans-serif !important',
      color: 'inherit'
    },
    allowBreak: {
      whiteSpace: 'pre-line'
    },
    h1: _extends({}, theme.typography.h1, {
      fontSize: '96px',
      lineHeight: 1.17,
      letterSpacing: '-1.5px',
      fontWeight: 900
    }),
    h2: _extends({}, theme.typography.h2, {
      fontSize: '60px',
      letterSpacing: '-0.5px',
      fontWeight: 800,
      lineHeight: 1.2
    }),
    h3: _extends({}, theme.typography.h3, {
      fontSize: '48px',
      fontWeight: 800,
      lineHeight: 1.17
    }),
    h4: _extends({}, theme.typography.h4, {
      fontSize: '34px',
      fontWeight: 800,
      lineHeight: 1.06
    }),
    h5: _extends({}, theme.typography.h5, {
      fontSize: '24px',
      fontWeight: 800,
      lineHeight: 1,
      letterSpacing: '0.18px'
    }),
    h6: _extends({}, theme.typography.h6, {
      fontSize: '20px',
      fontWeight: 800,
      lineHeight: 1.2,
      letterSpacing: '0.15px'
    }),
    subtitle1: _extends({}, theme.typography.subtitle2, {
      fontSize: '16px',
      fontWeight: 'bold',
      lineHeight: 1.5,
      letterSpacing: '0.15px'
    }),
    subtitle2: _extends({}, theme.typography.subtitle2, {
      fontSize: '14px',
      fontWeight: 'bold',
      lineHeight: 1.71,
      letterSpacing: '0.1px'
    }),
    body1: _extends({}, theme.typography.body1, {
      fontSize: '16px',
      lineHeight: 1.5,
      letterSpacing: '0.5px'
    }),
    body2: _extends({}, theme.typography.body2, {
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '0.25px'
    }),
    button: _extends({}, theme.typography.button, {
      fontSize: '16px',
      lineHeight: 1.5,
      letterSpacing: '0.5px'
    }),
    caption: _extends({}, theme.typography.caption, {
      fontSize: '12px',
      lineHeight: 1.33,
      letterSpacing: '0.4px'
    }),
    initial: {
      color: 'inherit'
    },
    inherit: {
      color: 'inherit'
    },
    primary: {
      color: theme.palette.primary.main
    },
    secondary: {
      color: theme.palette.secondary.main
    },
    tertiary: {
      color: (_theme$palette$tertia = theme.palette.tertiary) === null || _theme$palette$tertia === void 0 ? void 0 : _theme$palette$tertia.main
    },
    textPrimary: {
      color: theme.palette.text.primary
    },
    textSecondary: {
      color: theme.palette.text.secondary
    },
    error: {
      color: theme.palette.error.main
    }
  };
});